import React from "react";
import "../../styles/profile/ProfileLeftSide.css";

function ProfileLeftSide({ activeIndex, onSectionChange }) {
  return (
    <div className="ProfileLeftSide d">
      <div className="sidebar">
        <div className="sidebarMenu">
          <ul className="nk-menu">
            <li className="PRofile-heading">
              <h6>Profile Settings</h6>
            </li>

            <li className={`PRofile-item ${activeIndex === 0 ? "active" : ""}`}>
              <button
                className="item-content"
                onClick={() => onSectionChange(0)}
                style={{
                  border: "none",
                  background: "transparent",
                  width: "100%",
                  textAlign: "left",
                  cursor: "pointer",
                  appearance: "none",
                  fontFamily: "inherit",
                }}
              >
                <span>Your Profile</span>
              </button>
            </li>

            {/* <li className={`PRofile-item ${activeIndex === 1 ? "active" : ""}`}>
              <button
                className="item-content"
                onClick={() => onSectionChange(1)}
                style={{
                  border: "none",
                  background: "transparent",
                  width: "100%",
                  textAlign: "left",
                  cursor: "pointer",
                  appearance: "none",
                  fontFamily: "inherit",
                }}
              >
                <span>Fotographiya Wallet</span>
                <img src="./images/new-2.png" width="40px" alt="icon" />
              </button>
            </li>

            <li className={`PRofile-item ${activeIndex === 2 ? "active" : ""}`}>
              <button
                className="item-content"
                onClick={() => onSectionChange(2)}
                style={{
                  border: "none",
                  background: "transparent",
                  width: "100%",
                  textAlign: "left",
                  cursor: "pointer",
                  appearance: "none",
                  fontFamily: "inherit",
                }}
              >
                <span>Transactions</span>
                <img src="./images/new-2.png" width="40px" alt="icon" />
              </button>
            </li> */}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ProfileLeftSide;
